import { render, staticRenderFns } from "./orderService.vue?vue&type=template&id=2613a1ca&scoped=true"
import script from "./orderService.vue?vue&type=script&lang=js"
export * from "./orderService.vue?vue&type=script&lang=js"
import style0 from "./orderService.vue?vue&type=style&index=0&id=2613a1ca&prod&lang=less&scoped=true"
import style1 from "./orderService.vue?vue&type=style&index=1&id=2613a1ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2613a1ca",
  null
  
)

export default component.exports